export default `
precision highp float;
attribute vec2 aCurrent;
uniform highp vec2 uDomainX; 
uniform highp vec2 uDomainY;  
void main(void) { 
  highp vec2 bias = vec2(uDomainX.x, uDomainY.x);
  // the range in the viewport goes from -1 to 1
  // so we muiltiply by 2 (the scale will divide)
  highp float x_scale = (uDomainX.y - uDomainX.x)/2.0;
  highp float y_scale = (uDomainY.y - uDomainY.x)/2.0;
  // origin is at -1 , -1
  highp vec2 viewportBias = vec2(1.0,1.0);
  highp vec2 currentScaled = aCurrent - bias ;
  currentScaled.x /= x_scale;
  currentScaled.y /= y_scale;
  // move vertex according to normal and direction
  highp vec2 p = currentScaled - viewportBias;
  gl_Position = vec4(p,0.0, 1.0); 
}
`;
//# sourceMappingURL=areaVertexShader.js.map